import styled from "styled-components";
import { BREAKPOINTS } from "../../variables/Breakpoints";

export const LotusRenderWrapper = styled.div`
  height: 85vh;
  width: 100vw;
  @media (max-width: ${BREAKPOINTS.xl}px) {
    height: 75vh;
  }
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: 65vh;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: 60vh;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    height: 50vh;
  }
`;

export const LotusWebcamWrapper = styled.div`
  height: 95vh;
  width: 100vw;
  > div {
    margin-top: 3rem;
  }
  @media (max-width: ${BREAKPOINTS.lg}px) {
    height: 90vh;
  }
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: 70vh;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: 100vh;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    height: 100vh;
    > div {
      margin-top: 0;
    }
  }
`;

export const LotusContainer = styled.div`
  #lotus_ledbylight canvas,
  #lotus_render canvas {
    display: block;
    width: 100% !important;
    height: auto !important;
    image-rendering: pixelated;
    max-height: 100vh;
  }

  #lotus_render canvas {
    cursor: grab;
  }

  @media (max-aspect-ratio: 1/1) {
    #lotus_ledbylight canvas,
    #lotus_render canvas {
      object-fit: initial;
      //   position: absolute;
      //   bottom: 0;
      //   left: 0;
      height: auto !important;
    }
  }

  #lotus_render {
    position: relative;
  }
  #lotus_ledbylight {
    background: transparent;
  }
`;
